import { Link } from 'react-router-dom';

export default function HomeHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20content%20curation%20concept%20with%20warm%20cream%20and%20amber%20gradient%20background%2C%20soft%20geometric%20patterns%2C%20abstract%20flowing%20lines%20representing%20content%20organization%2C%20subtle%20Asian%20aesthetic%20elements%2C%20warm%20sophisticated%20atmosphere%2C%20no%20text%2C%20no%20people&width=1800&height=900&seq=home-hero-bg&orientation=landscape"
          alt="亚洲精品内容分区导览"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="animate-fade-in-up text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
          精选内容分区导览
        </h1>
        <p className="animate-fade-in-up animate-delay-200 text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          亚洲精品一区二区为您提供专业分区内容导览，涵盖一区精品推荐与二区优质资源，
          精准分类、快速定位，满足您对亚洲精品内容的多样化需求
        </p>
        <div className="animate-fade-in-up animate-delay-400 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/yiqu"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 px-8 py-3 rounded-md font-medium text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-star-line"></i>
            探索一区精品
          </Link>
          <Link
            to="/category/erqu"
            className="inline-flex items-center gap-2 bg-background-50/15 hover:bg-background-50/25 text-background-50 border border-background-50/30 px-8 py-3 rounded-md font-medium text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-sparkling-line"></i>
            发现二区资源
          </Link>
        </div>
      </div>
    </section>
  );
}